<template>
  <div class="converdy-editor-wrapper">
    <div class="converdy-editor" :data-text="code"></div>
  </div>
</template>
<script>
export default {
  name: 'CodeEditor',
  data() {
    return {
      editing: false,
      editor: null,
    };
  },
  props: {
    onCodeChanged: Function,
    code: String,
  },
  async mounted() {
    const baseUrl = 'https://cdn.jsdelivr.net/npm/monaco-editor@0.33/min';
    const editorElement = document.querySelector('.converdy-editor');
    const loadScript = (scriptUrl) => {
      return new Promise((accept, reject) => {
        if (document.getElementById(`${btoa(scriptUrl)}`)) {
          accept();
          return;
        }
        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.id = btoa(scriptUrl);
        document.body.appendChild(script);
        script.onload = () => {
          accept();
        };
      });
    };
    this.editor = {
      instance: null,
      init: (element) =>
        new Promise(async (accept) => {
          await loadScript(`${baseUrl}/vs/loader.js`);
          await loadScript(
            'https://cdn.jsdelivr.net/npm/emmet-monaco-es@5.2.1/dist/emmet-monaco.min.js',
          );

          window.require.config({
            paths: {vs: `${baseUrl}/vs`},
          });
          let proxy = URL.createObjectURL(
            new Blob(
              [
                `
                  self.MonacoEnvironment = {baseUrl: "${baseUrl}" + "/"};
                  importScripts("${baseUrl}" + '/vs/base/worker/workerMain.js');
                 `,
              ],
              {type: 'text/javascript'},
            ),
          );

          window.MonacoEnvironment = {getWorkerUrl: () => proxy};

          window.require(['vs/editor/editor.main'], () => {
            this.editor.instance = monaco.editor.create(element, {
              language: 'text/html',
              fontSize: '16px',
              theme: 'vs',
              fontFamily: `'Fira Code', Consolas, 'Courier New', monospace`,
              fontLigatures: true,
              automaticLayout: true,
              minimap: {
                enabled: false,
              },
              mouseWheelZoom: true,
              // wordWrap: "wordWrapColumn",
              // wordWrapColumn: 50,
              wordWrapMinified: true,
              wrappingIndent: 'same',
              scrollbar: {
                useShadows: false,
                verticalHasArrows: true,
                horizontalHasArrows: true,
                vertical: 'visible',
                horizontal: 'visible',
                verticalScrollbarSize: 17,
                horizontalScrollbarSize: 17,
                arrowSize: 30,
              },
            });

            emmetMonaco.emmetJSX();
            emmetMonaco.emmetHTML();
            emmetMonaco.emmetCSS();

            accept();
          });
        }),
      setValue: (value) => {
        this.editor.instance.getModel().setValue(value);
      },
    };

    await this.editor.init(editorElement);
    this.editor.setValue(this.code);
    this.editor.instance.onDidChangeModelContent(() => {
      this.onCodeChanged(this.editor.instance.getValue());
    });
  },
  async destroyed() {
    this.editor.instance.getModel().dispose();
    this.editor.instance.dispose();
  },
};
</script>

<style lang="scss">
.converdy-editor-wrapper {
  position: relative;
  height: 550px;
  width: 100%;
  .converdy-editor {
    display: block;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    box-shadow: inset 0px 0px 1000px 1000px rgba(255, 255, 255, 0.75);
    .mtk1 {
      color: #0057b4 !important;
    }

    .mtk6 {
      color: #0c3160 !important;
    }

    .mtk10 {
      color: #0057b4 !important;
    }

    .mtk14 {
      color: #2f91fc !important;
    }

    .mtk4 {
      color: #2f91fc !important;
    }
    .monaco-editor-background,
    .monaco-editor {
      background: transparent !important;
    }
  }
}
</style>
